<app-image-cropper [src]="imgUrl"
                   [settings]="settings.cropper"
                   (confirm)="confirm($event)"></app-image-cropper>